const NauruSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111983)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M20 0C9.54031 0 0.957656 8.02977 0.0761719 18.2609H39.9239C39.0423 8.02977 30.4597 0 20 0Z"
        fill="#0052B4"
      />
      <path
        d="M20 40.0011C30.4597 40.0011 39.0423 31.9713 39.9239 21.7402H0.0761719C0.957656 31.9713 9.54031 40.0011 20 40.0011Z"
        fill="#0052B4"
      />
      <path
        d="M16.5215 26.9576L14.2804 28.0118L15.4738 30.1822L13.0403 29.7166L12.7319 32.175L11.0369 30.367L9.34186 32.175L9.0335 29.7166L6.5999 30.1821L7.79334 28.0117L5.55225 26.9576L7.79342 25.9034L6.5999 23.7331L9.03342 24.1986L9.34193 21.7402L11.0369 23.5483L12.732 21.7402L13.0403 24.1986L15.4739 23.7331L14.2805 25.9035L16.5215 26.9576Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111983">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NauruSvg;
